/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectTitleField
 */
export interface ProjectTitleField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof ProjectTitleField
     */
    value: string;
}

/**
 * Check if a given object implements the ProjectTitleField interface.
 */
export function instanceOfProjectTitleField(value: object): value is ProjectTitleField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ProjectTitleFieldFromJSON(json: any): ProjectTitleField {
    return ProjectTitleFieldFromJSONTyped(json, false);
}

export function ProjectTitleFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectTitleField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function ProjectTitleFieldToJSON(value?: ProjectTitleField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

